import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getTerms } from "../httpService";
import { getSnapshotValue, hasSnapshotValue } from "../snapshot.js";
import { UserContext } from "./UserContext";

const TermsContext = createContext({ sections: [], loading: true, error: null });

const TermsContextProvider = (props) => {
  const [sections, setSections] = useState(() => getSnapshotValue("terms", []));
  const [loading, setLoading] = useState(() => !hasSnapshotValue("terms"));
  const [error, setError] = useState(null);
  const { locale } = useContext(UserContext);

  const initializeData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getTerms(locale);
      setSections(data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [locale]);

  useEffect(() => {
    initializeData();
  }, [initializeData]);

  const value = {
    sections,
    loading,
    error,
    reinitialize: initializeData,
  };

  return <TermsContext.Provider value={value} {...props} />;
};

export { TermsContextProvider, TermsContext };
